import { AxiosResponse } from "axios";
import { Requests } from "config/api";
import { getRequest } from "api/commonActions/get";
import { patchRequest } from "api/commonActions/update";
import {
  GetSettingProps,
  GetSettingReturnType,
  UpdateAppUpdatePolicyProps,
  UpdateAppUpdatePolicyReturnType,
} from "declarations/settingServices";

export const GetSetting = async ({
  setLoading,
}: GetSettingProps): Promise<GetSettingReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getSetting,
    });
    setLoading && setLoading(false);

    return {
      status: response?.status,
      message: response?.data?.msg || response?.data?.error,
      detail: response?.data?.detail || null,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const UpdateAppUpdatePolicy = async ({
  setLoading,
  androidMinimumBuild,
  androidLatestBuild,
  androidUpdateTitle,
  androidUpdateMessage,
  playstore,
}: UpdateAppUpdatePolicyProps): Promise<UpdateAppUpdatePolicyReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await patchRequest({
      route: Requests.update.updateAppUpdatePolicy,
      payload: {
        androidMinimumBuild,
        androidLatestBuild,
        androidUpdateTitle,
        androidUpdateMessage,
        playstore,
      },
    });
    setLoading && setLoading(false);

    return {
      status: response?.status,
      message:
        response?.data?.msg || response?.data?.error || response?.data?.details,
      detail: response?.data?.detail || null,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};
